import React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import { isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import { useTheme } from '../Themes';
import VFText from '../VFText';

import Styles from './VFItem.Styles';

const VFItem = ({
  name,
  leftIcon,
  rightIcon,
  leftIconSize,
  rightIconSize,
  leftIconStyle,
  rightIconStyle,
  onRightIconPress,
  disabled,
  onPress,
  containerStyle,
  nameTextStyle,
  itemTestID,
  vfTextProps,
  rightIconTouchableProps,
  rightIconTestID,
  ...props
}) => {
  const theme = useTheme();

  return (
    <TouchableWithoutFeedback
      disabled={disabled}
      onPress={() => onPress({ name, leftIcon, rightIcon, ...props })}
      testID={itemTestID}
      accessible={false}
    >
      <View style={[Styles.containerStyle(theme), containerStyle, { cursor: disabled ? null : 'pointer' }]}>
        {leftIcon ? (
          <Icon
            type="image"
            name={leftIcon}
            size={leftIconSize}
            style={[Styles.leftIconStyle, leftIconStyle]}
            testID={`${FoundationTestKeys.leftIcon}${itemTestID}`}
          />
        ) : null}
        <VFText i18nKey={name} style={[Styles.titleStyle(theme), nameTextStyle]} {...vfTextProps} />
        {rightIcon ? (
          <TouchableWithoutFeedback
            onPress={onRightIconPress}
            disabled={!_isFunction(onRightIconPress)}
            {...rightIconTouchableProps}
          >
            <Icon
              type="image"
              name={rightIcon}
              size={rightIconSize}
              style={rightIconStyle}
              testID={`${rightIconTestID}${itemTestID}`}
            />
          </TouchableWithoutFeedback>
        ) : null}
      </View>
    </TouchableWithoutFeedback>
  );
};

VFItem.defaultProps = {
  onPress: item => { },
  vfTextProps: {},
  leftIconSize: 25,
  rightIconSize: 25,
  itemTestID: '',
  rightIconTestID: FoundationTestKeys.rightIcon,
};

VFItem.propTypes = {
  name: PropTypes.string.isRequired,
  leftIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  rightIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  leftIconSize: PropTypes.number,
  rightIconSize: PropTypes.number,
  onRightIconPress: PropTypes.func,
  disabled: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  containerStyle: ViewPropTypes.style,
  nameTextStyle: TextPropTypes.style,
  leftIconStyle: ViewPropTypes.style,
  rightIconStyle: ViewPropTypes.style,
  itemTestID: PropTypes.string,
  vfTextProps: PropTypes.object,
  rightIconTouchableProps: PropTypes.object,
  rightIconTestID: PropTypes.string,
};

export default VFItem;
